import { __decorate } from "tslib";
// Core
import { Component, Prop, Mixins } from 'vue-property-decorator';
// Extends
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import InboxManagerMixin from '@/helpers/vue_mixins/v3/copilot_inbox_manager/InboxManagerMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
// Children
import BaseTextArea from '@/components/v2/BaseTextArea';
import SwitchTransition from '@/components/page_transition/Switch.vue';
// Queries / Mutations
import UpdateGeneratedResponse from '@/plugins/graphql/mutations/copilot_inbox_manager/update-generated-response.gql';
let GeneratedResponse = class GeneratedResponse extends Mixins(ViewportSizeMixin, AlertMixin, InboxManagerMixin) {
    constructor() {
        super(...arguments);
        // Refs
        // States
        this.isSending = false;
        this.isEditing = false;
        // Data
        this.editedMessage = null;
    }
    get approveSendText() {
        return this.isEditing ? 'Send' : 'Approve';
    }
    get editCancelText() {
        return this.isEditing ? 'Cancel' : 'Edit';
    }
    get recommendedResponse() {
        return this.prompt.jsonCompletion?.answer || this.prompt.completion;
    }
    sendMessage() {
        if (this.isEditing) {
            this.selectActionMutation('edited');
        }
        else {
            this.selectActionMutation('accept');
        }
    }
    toggleEdit() {
        if (this.editedMessage === null) {
            this.editedMessage = this.recommendedResponse;
        }
        this.isEditing = !this.isEditing;
    }
    selectActionMutation(action) {
        this.isSending = true;
        let message = this.isEditing ? this.editedMessage : this.recommendedResponse;
        if (action === 'dismiss') {
            message = null;
            this.$emit('removeGeneration');
        }
        else {
            this.$emit('sendGeneration', message);
        }
        return this.$apollo
            .mutate({
            mutation: UpdateGeneratedResponse,
            variables: {
                input: {
                    promptUuid: this.prompt.base.uuid,
                    message: message?.trim() || null,
                    action,
                },
            },
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.isEditing = false;
            this.isSending = false;
        });
    }
};
__decorate([
    Prop({ type: Object, default: () => ({}) })
], GeneratedResponse.prototype, "prompt", void 0);
GeneratedResponse = __decorate([
    Component({
        components: {
            BaseTextArea,
            SwitchTransition,
        },
    })
], GeneratedResponse);
export default GeneratedResponse;
